<template>
  <div class="md-layout">
    <label class="md-layout-item md-small-size-100 md-size-100"
      >{{ $t("Mission Information") }}
    </label>
    <div class="md-layout-item md-small-hide md-size-90">
      &nbsp;
    </div>

    <div class="md-layout-item md-small-100 md-size-60">
      <div class="md-layout-item md-small-size-100 md-size-80">
        <md-field>
          <label>{{ $t("Mission Name") }}</label>
          <md-input
            name="missionname"
            data-vv-name="missionname"
            v-model="missionname"
            type="text"
            v-validate="'required|min:2'"
          ></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-small-hide md-size-90">
        &nbsp;
      </div>
      <div class="md-layout-item md-small-size-100 md-size-80">
        <md-datepicker v-model="selectedDate" @change="updateEvent">
          <label>{{ $t("Select Date") }}</label>
        </md-datepicker>
      </div>

      <div class="md-layout-item md-small-hide md-size-90">
        &nbsp;
      </div>
      <div class="md-layout">
        <label class="md-layout-item md-small-size-100 md-size-100"
          >{{ $t("Mission Start") }}
        </label>
        <div class="md-layout-item md-small-size-100 md-size-40">
          <md-field>
            <label for="fr_hour">Hour</label>
            <md-select
              v-model="fr_hour"
              name="fr_hour"
              id="fr_hour"
              @md-selected="updateEvent"
            >
              <md-option value="1">1</md-option>
              <md-option value="2">2</md-option>
              <md-option value="3">3</md-option>
              <md-option value="4">4</md-option>
              <md-option value="5">5</md-option>
              <md-option value="6">6</md-option>
              <md-option value="7">7</md-option>
              <md-option value="8">8</md-option>
              <md-option value="9">9</md-option>
              <md-option value="10">10</md-option>
              <md-option value="11">11</md-option>
              <md-option value="12">12</md-option>
              <md-option value="13">13</md-option>
              <md-option value="14">14</md-option>
              <md-option value="15">15</md-option>
              <md-option value="16">16</md-option>
              <md-option value="17">17</md-option>
              <md-option value="18">18</md-option>
              <md-option value="19">19</md-option>
              <md-option value="20">20</md-option>
              <md-option value="21">21</md-option>
              <md-option value="22">22</md-option>
              <md-option value="23">23</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-40">
          <md-field>
            <label for="fr_minute">Minute</label>
            <md-select
              v-model="fr_minute"
              name="fr_minute"
              id="fr_minute"
              @md-selected="updateEvent"
            >
              <md-option value="0">0</md-option>
              <md-option value="1">1</md-option>
              <md-option value="2">2</md-option>
              <md-option value="3">3</md-option>
              <md-option value="4">4</md-option>
              <md-option value="5">5</md-option>
              <md-option value="6">6</md-option>
              <md-option value="7">7</md-option>
              <md-option value="8">8</md-option>
              <md-option value="9">9</md-option>
              <md-option value="10">10</md-option>
              <md-option value="11">11</md-option>
              <md-option value="12">12</md-option>
              <md-option value="13">13</md-option>
              <md-option value="14">14</md-option>
              <md-option value="15">15</md-option>
              <md-option value="16">16</md-option>
              <md-option value="17">17</md-option>
              <md-option value="18">18</md-option>
              <md-option value="19">19</md-option>
              <md-option value="20">20</md-option>
              <md-option value="21">21</md-option>
              <md-option value="22">22</md-option>
              <md-option value="23">23</md-option>
              <md-option value="24">24</md-option>
              <md-option value="25">25</md-option>
              <md-option value="26">26</md-option>
              <md-option value="27">27</md-option>
              <md-option value="28">28</md-option>
              <md-option value="29">29</md-option>
              <md-option value="30">30</md-option>
              <md-option value="31">31</md-option>
              <md-option value="32">32</md-option>
              <md-option value="33">33</md-option>
              <md-option value="34">34</md-option>
              <md-option value="35">35</md-option>
              <md-option value="36">36</md-option>
              <md-option value="37">37</md-option>
              <md-option value="38">38</md-option>
              <md-option value="39">39</md-option>
              <md-option value="40">40</md-option>
              <md-option value="41">41</md-option>
              <md-option value="42">42</md-option>
              <md-option value="43">43</md-option>
              <md-option value="44">44</md-option>
              <md-option value="45">45</md-option>
              <md-option value="46">46</md-option>
              <md-option value="47">47</md-option>
              <md-option value="48">48</md-option>
              <md-option value="49">49</md-option>
              <md-option value="50">50</md-option>
              <md-option value="51">51</md-option>
              <md-option value="52">52</md-option>
              <md-option value="53">53</md-option>
              <md-option value="54">54</md-option>
              <md-option value="55">55</md-option>
              <md-option value="56">56</md-option>
              <md-option value="57">57</md-option>
              <md-option value="58">58</md-option>
              <md-option value="59">59</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-small-hide md-size-90">
          &nbsp;
        </div>
        <label class="md-layout-item md-small-size-100 md-size-100"
          >{{ $t("Mission End") }}
        </label>
        <div class="md-layout-item md-small-size-100 md-size-40">
          <md-field>
            <label for="en_hour">Hour</label>
            <md-select
              v-model="en_hour"
              name="en_hour"
              id="en_hour"
              @md-selected="updateEvent"
            >
              <md-option value="1">1</md-option>
              <md-option value="2">2</md-option>
              <md-option value="3">3</md-option>
              <md-option value="4">4</md-option>
              <md-option value="5">5</md-option>
              <md-option value="6">6</md-option>
              <md-option value="7">7</md-option>
              <md-option value="8">8</md-option>
              <md-option value="9">9</md-option>
              <md-option value="10">10</md-option>
              <md-option value="11">11</md-option>
              <md-option value="12">12</md-option>
              <md-option value="13">13</md-option>
              <md-option value="14">14</md-option>
              <md-option value="15">15</md-option>
              <md-option value="16">16</md-option>
              <md-option value="17">17</md-option>
              <md-option value="18">18</md-option>
              <md-option value="19">19</md-option>
              <md-option value="20">20</md-option>
              <md-option value="21">21</md-option>
              <md-option value="22">22</md-option>
              <md-option value="23">23</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-40">
          <md-field>
            <label for="en_minute">Minute</label>
            <md-select
              v-model="en_minute"
              name="en_minute"
              id="en_minute"
              @md-selected="updateEvent"
            >
              <md-option value="0">0</md-option>
              <md-option value="1">1</md-option>
              <md-option value="2">2</md-option>
              <md-option value="3">3</md-option>
              <md-option value="4">4</md-option>
              <md-option value="5">5</md-option>
              <md-option value="6">6</md-option>
              <md-option value="7">7</md-option>
              <md-option value="8">8</md-option>
              <md-option value="9">9</md-option>
              <md-option value="10">10</md-option>
              <md-option value="11">11</md-option>
              <md-option value="12">12</md-option>
              <md-option value="13">13</md-option>
              <md-option value="14">14</md-option>
              <md-option value="15">15</md-option>
              <md-option value="16">16</md-option>
              <md-option value="17">17</md-option>
              <md-option value="18">18</md-option>
              <md-option value="19">19</md-option>
              <md-option value="20">20</md-option>
              <md-option value="21">21</md-option>
              <md-option value="22">22</md-option>
              <md-option value="23">23</md-option>
              <md-option value="24">24</md-option>
              <md-option value="25">25</md-option>
              <md-option value="26">26</md-option>
              <md-option value="27">27</md-option>
              <md-option value="28">28</md-option>
              <md-option value="29">29</md-option>
              <md-option value="30">30</md-option>
              <md-option value="31">31</md-option>
              <md-option value="32">32</md-option>
              <md-option value="33">33</md-option>
              <md-option value="34">34</md-option>
              <md-option value="35">35</md-option>
              <md-option value="36">36</md-option>
              <md-option value="37">37</md-option>
              <md-option value="38">38</md-option>
              <md-option value="39">39</md-option>
              <md-option value="40">40</md-option>
              <md-option value="41">41</md-option>
              <md-option value="42">42</md-option>
              <md-option value="43">43</md-option>
              <md-option value="44">44</md-option>
              <md-option value="45">45</md-option>
              <md-option value="46">46</md-option>
              <md-option value="47">47</md-option>
              <md-option value="48">48</md-option>
              <md-option value="49">49</md-option>
              <md-option value="50">50</md-option>
              <md-option value="51">51</md-option>
              <md-option value="52">52</md-option>
              <md-option value="53">53</md-option>
              <md-option value="54">54</md-option>
              <md-option value="55">55</md-option>
              <md-option value="56">56</md-option>
              <md-option value="57">57</md-option>
              <md-option value="58">58</md-option>
              <md-option value="59">59</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-align-center md-size-80 md-small-hide">
        <div class="md-layout-item md-small-hide md-size-90">
          &nbsp;
        </div>
        <div class="md-layout-item md-small-hide md-size-90">
          &nbsp;
        </div>
        <img src="/img/task-board-01.png" class="rounded-corner" />
      </div>
    </div>
    <!--<div class="md-layout-item md-small-size-100 md-size-20">
      <md-field>
        <label>NOW</label>
        <md-input
          name="minDatetime"
          data-vv-name="minDatetime"
          v-model="minDatetime"
          type="text"
        ></md-input>
      </md-field>
    </div>
     <div class="md-layout-item md-small-size-100 md-size-20">
      <md-field>
        <label>offset</label>
        <md-input
          name="tz_offset"
          data-vv-name="tz_offset"
          v-model="tz_offset"
          type="text"
        ></md-input>
      </md-field>
    </div>

   <div class="md-layout-item md-small-size-100 md-size-20">
      <md-field>
        <label>{{ $t("Start") }}</label>
        <md-input
          name="start"
          data-vv-name="start"
          v-model="start"
          type="text"
        ></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-20">
      <md-field>
        <label>{{ $t("End") }}</label>
        <md-input
          name="end"
          data-vv-name="end"
          v-model="end"
          type="text"
        ></md-input>
      </md-field>
    </div> -->
  </div>
</template>
<script>
import swal from "sweetalert2";
import moment from "moment";

var today = new Date();
today.setMinutes(today.getMinutes() + 10);
var now_date =
  today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
var now_time = (
  today.getHours() +
  ":" +
  today.getMinutes() +
  ":" +
  today.getSeconds()
).toString();
var timedifference = new Date().getTimezoneOffset();

export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      events: [],
      missionname: 'Mission ' + moment(new Date()).format('MM-DD-YYYY'),
      fr_hour: today.getHours(),
      fr_minute: today.getMinutes(),
      en_hour: 23,
      en_minute: 59,
      dt_start: null,
      dt_start_loc: null,
      dt_end: null,
      dt_end_loc: null,
      start: today,
      end: null,
      str_start: null,
      minDatetime: new Date().toISOString(),
      tz_offset: timedifference,
      str_end: now_date + "T23:59:00.00Z",
      t_now: now_time,
      selectedDate: now_date
    };
  },
  mounted() {
    this.updateEvent();
  },
  methods: {
    updateEvent() {
      var todays = new Date();
      if (!this.selectedDate) {
        swal.fire({
          title: this.$t("Please enter valid Date"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        return false;
      }
      var str_mission_name = this.missionname;
      var str_selectedDate = this.selectedDate;
      var str_fr_hour = this.fr_hour;
      var str_fr_minute = this.fr_minute;
      var str_en_hour = this.en_hour;
      var str_en_minute = this.en_minute;
      this.events = [];

      if (str_fr_hour.toString().length < 2) {
        str_fr_hour = "0" + str_fr_hour.toString();
      }
      if (str_en_hour.toString().length < 2) {
        str_en_hour = "0" + str_en_hour.toString();
      }
      if (str_fr_minute.toString().length < 2) {
        str_fr_minute = "0" + str_fr_minute.toString();
      }
      if (str_en_minute.toString().length < 2) {
        str_en_minute = "0" + str_en_minute.toString();
      }
      this.str_start =
        str_selectedDate + "T" + str_fr_hour + ":" + str_fr_minute + ":00.00Z";
      this.str_end =
        str_selectedDate + "T" + str_en_hour + ":" + str_en_minute + ":00.00Z";
      this.dt_start_loc = new Date(this.str_start);
      this.dt_end_loc = new Date(this.str_end);
      this.dt_start = this.dt_start_loc.setMinutes(
        this.dt_start_loc.getMinutes() + this.tz_offset
      );
      this.dt_end = this.dt_end_loc.setMinutes(
        this.dt_end_loc.getMinutes() + this.tz_offset
      );

      const start = moment(this.dt_start).valueOf();
      const end = moment(this.dt_end).valueOf();
      if (start < +todays) {
        this.fr_hour = todays.getHours().toString();
        this.fr_minute = todays.getMinutes().toString();
        this.en_hour = 23;
        this.en_minute = 59;
        swal.fire({
          title: this.$t("You can not schedule your flight in the past!"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        return false;
      }
      if (start > end) {
        swal.fire({
          title: this.$t("Please adjust your time!"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        return false;
      } else if (this.missionname == "" || this.missionname.length < 2) {
        swal.fire({
          title: this.$t("Please add mission name"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        return false;
      }

      var event = {
        title: str_mission_name,
        start: moment(this.dt_start).utc(),
        end: moment(this.dt_end).utc(),
        start_loc: this.dt_start_loc,
        end_loc: this.dt_end_loc
      };
      this.events.push(event);
    },
    validate() {
      if (this.updateEvent() === false) {
        return;
      }
      if (this.events.length == 0) {
        swal.fire({
          title: this.$t("Please schedule your flight!"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
        return false;
      } else {
        this.$emit("on-validated", true, this.events);
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.md-datepicker-header .md-datepicker-year-select {
  color: white;
  cursor: pointer;
  opacity: 0.54;
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 24px;
}

.text-center {
  text-align: center;
}

img.rounded-corner {
  border-radius: 30px;
}
</style>
